import React from 'react';
import './TextArea.scss';

const TextArea = props => <textarea {...props} className='c-TextArea'></textarea>;

export default TextArea;
